/**
 * ##################################################################
 * # Account Action Types
 * ##################################################################
*/
import { END_SESSION_SUCCESS } from './session';

export const CLEAR_ERROR = 'ACCOUNT::CLEAR_ERROR';
export const CREATE_ACCOUNT_REQUEST_SENT = 'ACCOUNT::CREATE_ACCOUNT_REQUEST_SENT';
export const CREATE_ACCOUNT_REQUEST_SUCCESS = 'ACCOUNT::CREATE_ACCOUNT_REQUEST_SUCCESS';
export const CREATE_ACCOUNT_REQUEST_FAIL = 'ACCOUNT::CREATE_ACCOUNT_REQUEST_FAIL';
export const GET_ACCOUNT_REQUEST_SENT = 'ACCOUNT::GET_ACCOUNT_REQUEST_SENT';
export const GET_ACCOUNT_REQUEST_SUCCESS = 'ACCOUNT::GET_ACCOUNT_REQUEST_SUCCESS';
export const GET_ACCOUNT_REQUEST_FAIL = 'ACCOUNT::GET_ACCOUNT_REQUEST_FAIL';
export const GET_CARD_REQUEST_SENT = 'ACCOUNT::GET_CARD_REQUEST_SENT';
export const GET_CARD_REQUEST_SUCCESS = 'ACCOUNT::GET_CARD_REQUEST_SUCCESS';
export const GET_CARD_REQUEST_FAIL = 'ACCOUNT::GET_CARD_REQUEST_FAIL';
export const GET_PLAN_REQUEST_SENT = 'ACCOUNT::GET_PLAN_REQUEST_SENT';
export const GET_PLAN_REQUEST_SUCCESS = 'ACCOUNT::GET_PLAN_REQUEST_SUCCESS';
export const GET_PLAN_REQUEST_FAIL = 'ACCOUNT::GET_PLAN_REQUEST_FAIL';
export const SAVE_ACCOUNT_REQUEST_SENT = 'ACCOUNT::SAVE_ACCOUNT_REQUEST_SENT';
export const SAVE_ACCOUNT_REQUEST_SUCCESS = 'ACCOUNT::SAVE_ACCOUNT_REQUEST_SUCCESS';
export const SAVE_ACCOUNT_REQUEST_FAIL = 'ACCOUNT::SAVE_ACCOUNT_REQUEST_FAIL';
export const SET_ACCOUNT_DATA = 'ACCOUNT::SET_ACCOUNT_DATA';
export const SET_PASSWORD_REQUEST_SENT = 'ACCOUNT::SET_PASSWORD_REQUEST_SENT';
export const SET_PASSWORD_REQUEST_SUCCESS = 'ACCOUNT::SET_PASSWORD_REQUEST_SUCCESS';
export const SET_PASSWORD_REQUEST_FAIL = 'ACCOUNT::SET_PASSWORD_REQUEST_FAIL';
export const SET_NEW_PASSWORD_EMAIL_REQUEST_SENT = 'ACCOUNT::SET_NEW_PASSWORD_EMAIL_SENT';
export const SET_NEW_PASSWORD_EMAIL_REQUEST_SUCCESS = 'ACCOUNT::SET_NEW_PASSWORD_EMAIL_SUCCESS';
export const SET_NEW_PASSWORD_EMAIL_REQUEST_FAIL = 'ACCOUNT::SET_NEW_PASSWORD_EMAIL_FAIL';
export const VERIFY_TOKEN_REQUEST_SENT = 'SESSION::VERIFY_TOKEN_REQUEST_SENT';
export const VERIFY_TOKEN_REQUEST_SUCCESS = 'SESSION::VERIFY_TOKEN_REQUEST_SUCCESS';
export const VERIFY_TOKEN_REQUEST_FAIL = 'SESSION::VERIFY_TOKEN_REQUEST_FAIL';

const initialState = {
  createAccountRequestOut: false,
  error: undefined,
  getAccountRequestOut: false,
  getCardRequestOut: false,
  getPlanRequestOut: false,
  saveAccountRequestOut: false,
  info: {},
  setNewPasswordEmailRequestOut: false,
  setPasswordRequestOut: false,
  verifyTokenFail: false,
  verifyTokenRequestOut: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_ERROR:
      return { ...state, error: undefined, verificationFail: false };
    case CREATE_ACCOUNT_REQUEST_SENT:
      return { ...state, createAccountRequestOut: true, error: undefined };
    case CREATE_ACCOUNT_REQUEST_SUCCESS:
      return {
        ...state,
        createAccountRequestOut: false,
        info: action.info,
        error: undefined,
      };
    case CREATE_ACCOUNT_REQUEST_FAIL:
      return { ...state, createAccountRequestOut: false, error: action.error };
    case END_SESSION_SUCCESS:
      return { ...initialState };
    case GET_ACCOUNT_REQUEST_SENT:
      return { ...state, getAccountRequestOut: true, error: undefined };
    case GET_ACCOUNT_REQUEST_SUCCESS:
      return {
        ...state,
        getAccountRequestOut: false,
        info: action.info,
        error: undefined,
      };
    case GET_ACCOUNT_REQUEST_FAIL:
      return { ...state, getAccountRequestOut: false, error: action.error };
    case GET_CARD_REQUEST_SENT:
      return { ...state, getCardRequestOut: true, error: undefined };
    case GET_CARD_REQUEST_SUCCESS:
      return {
        ...state,
        getCardRequestOut: false,
        card: action.info,
        error: undefined,
      };
    case GET_CARD_REQUEST_FAIL:
      return { ...state, getCardRequestOut: false, error: action.error };
    case GET_PLAN_REQUEST_SENT:
      return { ...state, getPlanRequestOut: true, error: undefined };
    case GET_PLAN_REQUEST_SUCCESS:
      return {
        ...state,
        getPlanRequestOut: false,
        plan: action.info,
        error: undefined,
      };
    case GET_PLAN_REQUEST_FAIL:
      return { ...state, getPlanRequestOut: false, error: action.error };
    case SAVE_ACCOUNT_REQUEST_SENT:
      return { ...state, saveAccountRequestOut: true, error: undefined };
    case SAVE_ACCOUNT_REQUEST_SUCCESS:
      return {
        ...state,
        saveAccountRequestOut: false,
        info: action.info,
        error: undefined,
      };
    case SAVE_ACCOUNT_REQUEST_FAIL:
      return { ...state, saveAccountRequestOut: false, error: action.error };
    case SET_ACCOUNT_DATA: {
      const newInfo = { ...state.info };
      newInfo[action.prop] = action.value;
      return { ...state, info: newInfo };
    }
    case SET_PASSWORD_REQUEST_SENT:
      return { ...state, setPasswordRequestOut: true, error: undefined };
    case SET_PASSWORD_REQUEST_SUCCESS:
      return {
        ...state,
        setPasswordRequestOut: false,
        info: action.info,
        error: undefined,
      };
    case SET_PASSWORD_REQUEST_FAIL:
      return { ...state, setPasswordRequestOut: false, error: action.error };
    case SET_NEW_PASSWORD_EMAIL_REQUEST_SENT:
      return { ...state, setNewPasswordEmailRequestOut: true, error: undefined };
    case SET_NEW_PASSWORD_EMAIL_REQUEST_SUCCESS:
      return { ...state, setNewPasswordEmailRequestOut: false, error: undefined };
    case SET_NEW_PASSWORD_EMAIL_REQUEST_FAIL:
      return { ...state, setNewPasswordEmailRequestOut: false, error: action.info };
    case VERIFY_TOKEN_REQUEST_SENT:
      return { ...state, verifyTokenRequestOut: true, verifyTokenFail: false };
    case VERIFY_TOKEN_REQUEST_SUCCESS:
      return {
        ...state,
        verifyTokenFail: false,
        verifyTokenRequestOut: false,
        password: action.password,
      };
    case VERIFY_TOKEN_REQUEST_FAIL:
      return { ...state, verifyTokenFail: true, verifyTokenRequestOut: false };
    default:
      return state;
  }
};

export const clearError = () => ({
  type: CLEAR_ERROR,
});

export const getAccount = () => (dispatch, getState) => {
  const { rmi } = getState();

  dispatch({ type: GET_ACCOUNT_REQUEST_SENT });
  return rmi.accounts.get()
    .then((info) => {
      dispatch({ type: GET_ACCOUNT_REQUEST_SUCCESS, info });
    })
    .catch((error) => {
      dispatch({ type: GET_ACCOUNT_REQUEST_FAIL, error });
    });
};

export const setAccountData = (prop, value) => ({
  type: SET_ACCOUNT_DATA,
  prop,
  value,
});

export const sendCreateAccountRequest = () => (dispatch, getState) => {
  const { rmi } = getState();
  const { email } = getState().session;

  dispatch({ type: CREATE_ACCOUNT_REQUEST_SENT });
  return rmi.accounts.post({ email, plan: 'remeeting_basic' })
    .then((info) => {
      dispatch({ type: CREATE_ACCOUNT_REQUEST_SUCCESS, info });
    })
    .catch((error) => {
      dispatch({ type: CREATE_ACCOUNT_REQUEST_FAIL, error });
    });
};

export const sendSetNewPasswordEmail = () => (dispatch, getState) => {
  const { rmi } = getState();
  const { email } = getState().session;

  dispatch({ type: SET_NEW_PASSWORD_EMAIL_REQUEST_SENT });
  return rmi.accounts.sendVerificationToken({ email })
    .then(() => {
      dispatch({ type: SET_NEW_PASSWORD_EMAIL_REQUEST_SUCCESS });
    })
    .catch((error) => {
      dispatch({ type: SET_NEW_PASSWORD_EMAIL_REQUEST_FAIL, error });
    });
};

export const sendSaveAccount = () => (dispatch, getState) => {
  const { rmi } = getState();
  const { info } = getState().account;

  dispatch({ type: SAVE_ACCOUNT_REQUEST_SENT });
  return rmi.accounts.put(info)
    .then((newInfo) => {
      dispatch({ type: SAVE_ACCOUNT_REQUEST_SUCCESS, info: newInfo });
    })
    .catch((error) => {
      dispatch({ type: SAVE_ACCOUNT_REQUEST_FAIL, error });
    });
};

export const sendSetPassword = (password, verificationToken) => (dispatch, getState) => {
  const { rmi } = getState();
  const { email } = getState().session;

  dispatch({ type: SET_PASSWORD_REQUEST_SENT });
  return rmi.accounts.setPassword({ email, verificationToken, newPassword: password })
    .then((info) => {
      dispatch({ type: SET_PASSWORD_REQUEST_SUCCESS, info });
    })
    .catch((error) => {
      dispatch({ type: SET_PASSWORD_REQUEST_FAIL, error });
    });
};

export const sendGetCard = () => (dispatch, getState) => {
  const { rmi } = getState();

  dispatch({ type: GET_CARD_REQUEST_SENT });
  return rmi.accounts.getCard()
    .then((info) => {
      const card = info.number ? info : undefined;
      dispatch({ type: GET_CARD_REQUEST_SUCCESS, info: card });
    })
    .catch((error) => {
      dispatch({ type: GET_CARD_REQUEST_FAIL, error });
    });
};

export const sendGetPlan = () => (dispatch, getState) => {
  const { rmi } = getState();

  dispatch({ type: GET_PLAN_REQUEST_SENT });
  return rmi.accounts.getPlan()
    .then((info) => {
      dispatch({ type: GET_PLAN_REQUEST_SUCCESS, info });
    })
    .catch((error) => {
      dispatch({ type: GET_PLAN_REQUEST_FAIL, error });
    });
};

export const verifyVerificationToken = (verificationToken) => (dispatch, getState) => {
  const { rmi } = getState();

  dispatch({ type: VERIFY_TOKEN_REQUEST_SENT });

  const rq = rmi.accounts.verifyVerificationToken({ verificationToken });

  rq.then(() => {
    dispatch({ type: VERIFY_TOKEN_REQUEST_SUCCESS });
  });

  rq.catch((error) => {
    dispatch({ type: VERIFY_TOKEN_REQUEST_FAIL, error });
  });

  return rq;
};
